import { combineReducers } from 'redux';

import authenticityToken from './authenticityToken';
import sessionToken from './sessionToken';
import analytics from './analytics';
import creditApplication from './creditApplication';
import instantCredit from './instantCredit';
import iovation from './iovation';
import storeLocations from './storeLocations';
import tenant from './tenant';
import timeouts from './timeouts';
import prescreen from './prescreen';
import otpCode from './otpCode';
import prequalOffer from './prequalOffer';
import consumerSearch from './consumerSearch';
import driversLicense from './driversLicense';
import enhancedCheckout from './enhancedCheckout';
import membershipValidation from './membershipValidation';

const reducer = combineReducers({
  authenticityToken,
  sessionToken,
  analytics,
  creditApplication,
  instantCredit,
  iovation,
  storeLocations,
  tenant,
  timeouts,
  prescreen,
  otpCode,
  prequalOffer,
  consumerSearch,
  driversLicense,
  enhancedCheckout,
  membershipValidation,
});

export default reducer;

export type State = ReturnType<typeof reducer>;
